// Use this so that result is a union of all keys of T instead of string[]
export function getKeys<T extends object>(object: T) {
  return Object.keys(object) as (keyof T)[];
}
